import {
  Card,
  Checkbox,
  FormControlLabel,
  Grid,
  Icon,
  Modal,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import React from "react";

const BasicInformationCard = ({
  courseInformation,
  onChangeHandler,
  errors,
  setImageModalOpenState,
  imageModalOpenState,
  has_quiz,
  questions_file,
  certificate_path,
}) => {
  const [questionsModalOpenState, setQuestionsModalOpenState] =
    React.useState(false);
  const [certificateModalOpenState, setCertificateModalOpenState] =
    React.useState(false);

  return (
    <Card
      style={{
        width: "100%",
        padding: "20px",
        justifyItems: "center",
      }}
    >
      <MDTypography variant="h5" mb={2}>
        Basic Course Information
      </MDTypography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label="Course Name"
            name="name"
            value={courseInformation.name}
            onChange={onChangeHandler}
          />
          {errors.name_error && (
            <Typography variant="body2" color="error">
              Course name is required
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} display="flex" justifyContent="space-between">
          <TextField
            fullWidth
            required
            label="Course Image URL"
            name="image_location"
            value={courseInformation.image_location}
            onChange={onChangeHandler}
          />
          <MDButton
            variant="contained"
            
            style={{ float: "right", marginLeft: "10px" }}
            onClick={() => setImageModalOpenState(true)}
          >
            Preview
          </MDButton>
          {imageModalOpenState && (
            <Modal
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              open={imageModalOpenState}
              onClose={() => setImageModalOpenState(false)}
            >
              <Card
                style={{
                  width: "50%",
                  padding: "20px",
                  justifyItems: "center",
                  display: "flex",
                }}
              >
                <img
                  src={courseInformation.image_location}
                  alt="Course Image"
                />
              </Card>
            </Modal>
          )}
          {errors.image_location_error && (
            <Typography variant="body2" color="error">
              Course image is required
            </Typography>
          )}
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            required
            rows={4}
            label="Short Description"
            name="short_description"
            value={courseInformation.short_description}
            onChange={onChangeHandler}
          />
          {errors.short_description_error && (
            <Typography variant="body2" color="error">
              Short description is required
            </Typography>
          )}
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="External Link"
            name="external_link"
            value={courseInformation.external_link}
            onChange={onChangeHandler}
          />
          <Typography variant="caption" color="secondary">
            Put the external link here. This can be a stripe link for payment or a link to an external course page. If this is provided, users will be redirected to this link when they click on the course. If not provided, users will stay within the QUSkillBridge platform when they click on the course.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                name="has_quiz"
                checked={has_quiz}
                onChange={(ex) => {
                  let e = {
                    target: {
                      name: "has_quiz",
                      value: ex.target.checked,
                    },
                  };
                  onChangeHandler(e);
                }}
                color="primary"
              />
            }
            label="Course has a quiz"
          />
        </Grid>
        {has_quiz && (
          <>
            <Grid item xs={12} display="flex" justifyContent="space-between">
              <TextField
                fullWidth
                required
                label="Questions File URL"
                name="questions_file"
                value={questions_file}
                onChange={onChangeHandler}
              />
              <MDButton
                variant="contained"
                style={{ float: "right", marginLeft: "10px" }}
                onClick={() => setQuestionsModalOpenState(true)}
              >
                Instructions
              </MDButton>
              <Modal
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                open={questionsModalOpenState}
                onClose={() => setQuestionsModalOpenState(false)}
              >
                <Card
                  style={{
                    width: "50%",
                    padding: "20px",
                    display: "flex",
                  }}
                >
                  <Typography variant="body1">
                    Add the s3 link to the questions file. The questions should
                    have the format:
                  </Typography>

                  <pre>
                    {" "}
                    <code>
                      {JSON.stringify(
                        {
                          module_name: [
                            {
                              question: "",
                              options: [
                                "have",
                                "four",
                                "choices",
                                "compulsorily",
                              ],
                              answer_option: "a/b/c/d",
                              explanation: "",
                              uuid: "unique id",
                            },
                            "...other_questions"
                          ],
                          "...other_modules":[]
                        },

                        null,
                        2
                      )}
                    </code>
                  </pre>
                </Card>
              </Modal>
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="space-between">
              <TextField
                fullWidth
                required
                label="Certificate Path"
                name="certificate_path"
                value={certificate_path}
                onChange={onChangeHandler}
              />
              <MDButton
                variant="contained"
                style={{
                  float: "right",
                  marginLeft: "10px",
                  marginTop: "10px",
                }}
                onClick={() => setCertificateModalOpenState(true)}
              >
                Instructions
              </MDButton>
              <Modal
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                open={certificateModalOpenState}
                onClose={() => setCertificateModalOpenState(false)}
              >
                <Card
                  style={{
                    width: "50%",
                    padding: "20px",
                    display: "flex",
                  }}
                >
                  <Typography variant="body1">
                    Add the s3 link to the certificate file. It should be a jpg image. <br />
                    Use a 960x540 image. Use this <a target="_blank" href="https://docs.google.com/presentation/d/1XBCW7ntK7gL8qXbix_vBcdx8sFYmN7MV8A5tGkttagI/edit?slide=id.p#slide=id.p">template</a> to generate the certicate.
                  </Typography>
                </Card>
              </Modal>
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Disclaimer"
            name="disclaimer"
            multiline
            role={3}
            value={courseInformation.disclaimer}
            onChange={onChangeHandler}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default BasicInformationCard;
